import Text from './src/text.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';

export const ToText: SFCWithInstall<typeof Text> = withInstall(Text);

export * from './src/instance';